'use client';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsOrg } from '#/modules/search/constants/useSearchFacetsOrg';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { searchShouldShowSortOptions } from '#/modules/search/helpers/searchShouldShowSortOptions';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';
import type { DatetimeString } from '#/types/TypedDateString';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

type Props = {
  now: DatetimeString;
};

export function SearchOrgsPage({ now }: Props) {
  const { i18n } = useI18n();

  const query = useSearchQuery();
  const filters = useSearchFiltersByName();

  const location = useLocation();
  useEffect(() => {
    trackPageView('Search Orgs');
  }, [location.key]);

  const { orgSearchFacets } = useSearchFacetsOrg(i18n);

  return (
    <SearchPage
      searchType="ORG"
      showSortOptions={searchShouldShowSortOptions({
        searchType: 'ORG',
        query,
        filters,
      })}
      searchFacets={orgSearchFacets}
      now={now}
    />
  );
}
